import { Navigate, useRoutes } from "react-router-dom";
import { useAppSelector } from "../hooks/useSelector";
import DashboardLayout from "../layouts/Dashboard";
import MinimalLayout from "../layouts/Minimal";
import AreaCreate from "../pages/area/AreaCreate";
import AreaEdit from "../pages/area/AreaEdit";
import AreaList from "../pages/area/AreaList";
import BlogCreate from "../pages/blog/BlogCreate";
import BlogDetail from "../pages/blog/BlogDetail";
import BlogEdit from "../pages/blog/BlogEdit";
import BlogList from "../pages/blog/BlogList";
import ContentCreate from "../pages/blog/ContentCreate";
import ContentEdit from "../pages/blog/ContentEdit";
import ChangePasswordPage from "../pages/ChangePasswordPage";
import ClusterCreate from "../pages/cluster/ClusterCreate";
import ClusterDetail from "../pages/cluster/ClusterDetail";
import ClusterEdit from "../pages/cluster/ClusterEdit";
import ClusterList from "../pages/cluster/ClusterList";
import NearbyCreate from "../pages/cluster/NearbyCreate";
import NearbyEdit from "../pages/cluster/NearbyEdit";
import Dashboard from "../pages/Dashboard";
import FacilityCreate from "../pages/facility/FacilityCreate";
import FacilityEdit from "../pages/facility/FacilityEdit";
import FacilityList from "../pages/facility/FacilityList";
import ForgotPage from "../pages/ForgotPage";
import LoadingPage from "../pages/LoadingPage";
import PageNotFound from "../pages/PageNotFound";
import PropertyCreate from "../pages/property/PropertyCreate";
import PropertyDetail from "../pages/property/PropertyDetail";
import PropertyEdit from "../pages/property/PropertyEdit";
import PropertyList from "../pages/property/PropertyList";
import RoomCreate from "../pages/property/RoomCreate";
import RoomDetail from "../pages/property/RoomDetail";
import RoomEdit from "../pages/property/RoomEdit";
import UnitCreate from "../pages/property/UnitCreate";
import UnitDetail from "../pages/property/UnitDetail";
import UnitEdit from "../pages/property/UnitEdit";
import RoleCreation from "../pages/roles/RoleCreate";
import RoleEdit from "../pages/roles/RoleEdit";
import RoleList from "../pages/roles/RoleList";
import SignInPage from "../pages/SignInPage";
import SurveyList from "../pages/survey/SurveyList";
import AccountProfilePage from "../pages/user/AccountProfilePage";
import UserCreate from "../pages/user/UserCreate";
import UserEdit from "../pages/user/UserEdit";
import UserList from "../pages/user/UserList";
import AuditTrailList from "../pages/audittrail/AuditTrailList";

export default function Routes() {
  const { menu } = useAppSelector((state) => state.global);
  const chooseDefaultRoute: any = () => {
    const availableMenu = menu.filter(
      (item: { link: any }) => item.link != null
    );
    if (availableMenu.length > 0) {
      return { element: <Navigate to={availableMenu[0].link} />, index: true };
    }
    return { element: <LoadingPage />, index: true };
  };
  return useRoutes([
    {
      path: "/app",
      element: <DashboardLayout />,
      children: [
        {
          path: "/app",
          children: [chooseDefaultRoute()],
        },
        {
          path: "/app/dashboard",
          children: [
            {
              path: "/app/dashboard",
              element: <Dashboard />,
              index: true,
            },
          ],
        },
        {
          path: "/app/audit-trail",
          children: [
            {
              path: "/app/audit-trail",
              element: <AuditTrailList />,
              index: true,
            },
          ],
        },
        {
          path: "/app/properties",
          children: [
            {
              path: "/app/properties",
              element: <Navigate to="/app/properties/area" />,
              index: true,
            },
            {
              path: "/app/properties/area",
              children: [
                {
                  element: <AreaList />,
                  path: "/app/properties/area",
                  index: true,
                },
                {
                  element: <AreaCreate />,
                  path: "/app/properties/area/create",
                },
                {
                  element: <AreaEdit />,
                  path: "/app/properties/area/edit/:id",
                },
              ],
            },
            {
              path: "/app/properties/facility",
              children: [
                {
                  element: <FacilityList />,
                  path: "/app/properties/facility",
                  index: true,
                },
                {
                  element: <FacilityCreate />,
                  path: "/app/properties/facility/create",
                },
                {
                  element: <FacilityEdit />,
                  path: "/app/properties/facility/edit/:id",
                },
              ],
            }, {
              path: "/app/properties/property",
              children: [
                {
                  element: <PropertyList />,
                  path: "/app/properties/property",
                  index: true,
                },
                {
                  element: <PropertyCreate />,
                  path: "/app/properties/property/create",
                },
                {
                  element: <PropertyEdit />,
                  path: "/app/properties/property/edit/:id",
                },
                {
                  element: <PropertyDetail />,
                  path: "/app/properties/property/detail/:id",
                },
                {
                  element: <RoomCreate />,
                  path: "/app/properties/property/:id/room/create",
                },
                {
                  element: <RoomEdit />,
                  path: "/app/properties/property/room/edit/:id",
                },
                {
                  element: <RoomDetail />,
                  path: "/app/properties/property/room/detail/:id",
                },
                {
                  element: <UnitCreate />,
                  path: "/app/properties/property/room/:id/unit/create",
                },
                {
                  element: <UnitEdit />,
                  path: "/app/properties/property/unit/edit/:id",
                },
                {
                  element: <UnitDetail />,
                  path: "/app/properties/property/unit/detail/:id",
                },
              ]
            },
            {
              path: "/app/properties/cluster",
              children: [
                {
                  element: <ClusterList />,
                  path: "/app/properties/cluster",
                  index: true,
                },
                {
                  element: <ClusterCreate />,
                  path: "/app/properties/cluster/create",
                },
                {
                  element: <ClusterEdit />,
                  path: "/app/properties/cluster/edit/:id",
                },
                {
                  element: <ClusterDetail />,
                  path: "/app/properties/cluster/detail/:id",
                },
                {
                  element: <NearbyCreate />,
                  path: "/app/properties/cluster/:id/nearby/create",
                },
                {
                  element: <NearbyEdit />,
                  path: "/app/properties/cluster/nearby/edit/:id",
                },
              ],
            },
          ],
        },
        {
          path: "/app/order",
          children: [
            {
              path: "/app/order",
              element: <Navigate to="/app/order/survey" />,
              index: true,
            },
            {
              element: <SurveyList />,
              path: "/app/order/survey",
            },
          ],
        },
        {
          path: "/app/cms",
          children: [
            {
              path: "/app/cms",
              element: <Navigate to="/app/cms/blog" />,
              index: true,
            },
            {
              element: <BlogList />,
              path: "/app/cms/blog",
            },
            {
              element: <BlogCreate />,
              path: "/app/cms/blog/create",
            },
            {
              element: <BlogEdit />,
              path: "/app/cms/blog/edit/:id",
            },
            {
              element: <BlogDetail />,
              path: "/app/cms/blog/detail/:id",
            },
            {
              element: <ContentCreate />,
              path: "/app/cms/blog/:id/content/create",
            },
            {
              element: <ContentEdit />,
              path: "/app/cms/blog/content/edit/:id",
            },
          ],
        },
        {
          path: "/app/profile",
          children: [
            { element: <AccountProfilePage />, index: true },
            {
              element: <ChangePasswordPage />,
              path: "/app/profile/change-password",
            },
          ],
        },
        {
          path: "/app/users",
          children: [
            {
              element: <Navigate to="/app/users/backoffice" />,
              index: true,
              path: "/app/users",
            },
            {
              element: <UserList users="backoffice" />,
              path: "/app/users/backoffice",
            },
            {
              element: <UserList users="tenant" />,
              path: "/app/users/tenant",
            },
            {
              element: <UserCreate />,
              path: "/app/users/create-user",
            },
            {
              element: <UserEdit />,
              path: "/app/users/edit/:id",
            },
            {
              path: "/app/users/roles",
              children: [
                {
                  element: <RoleList />,
                  path: "/app/users/roles",
                  index: true,
                },
                {
                  element: <RoleCreation />,
                  path: "/app/users/roles/create",
                },
                {
                  element: <RoleEdit />,
                  path: "/app/users/roles/edit/:id",
                },
              ],
            },
          ],
        },
        {
          path: "*",
          element: <PageNotFound fullWidth={false} />,
        },
      ],
    },
    {
      path: "/",
      element: <MinimalLayout />,
      children: [
        {
          path: "/",
          element: <SignInPage />,
        },
        {
          path: "/forgot-password",
          element: <ForgotPage />,
        },
        {
          path: "*",
          element: <PageNotFound fullWidth />,
        },
      ],
    },
  ]);
}
